import { ChangeDetectionStrategy, Component, Input, inject, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { OrderTemplatesFacade } from 'src/app/extensions/order-templates/facades/order-templates.facade';
import { OrderTemplate } from 'src/app/extensions/order-templates/models/order-template/order-template.model';

import { ProductContextDirective } from 'ish-core/directives/product-context.directive';
import { SkuQuantityType } from 'ish-core/models/product/product.model';
import { ModalDialogComponent } from 'ish-shared/components/common/modal-dialog/modal-dialog.component';
import { ModalDialogComponent as ModalDialogComponent_1 } from 'ish-shared/components/common/modal-dialog/modal-dialog.component';
import { ProductAddToBasketComponent } from 'ish-shared/components/product/product-add-to-basket/product-add-to-basket.component';

@Component({
  selector: 'custom-filter-order-template',
  templateUrl: './filter-order-template.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterLink,
    ProductAddToBasketComponent,
    ProductContextDirective,
    FaIconComponent,
    ModalDialogComponent_1,
    TranslateModule,
  ],
})
export class FilterOrderTemplateComponent {
  private orderTemplatesFacade = inject(OrderTemplatesFacade);
  private translate = inject(TranslateService);

  readonly showAllChange = output<boolean>();
  private showAllValue = false;
  readonly orderTemplates = input<OrderTemplate[]>(undefined);
  @Input()
  get showAll() {
    return this.showAllValue;
  }
  set showAll(val) {
    this.showAllValue = val;
    this.showAllChange.emit(this.showAllValue);
  }

  /** Emits the id of the order template to delete. */
  delete(orderTemplateId: string) {
    this.orderTemplatesFacade.deleteOrderTemplate(orderTemplateId);
  }

  /** Determine the heading of the delete modal and opens the modal. */
  openDeleteConfirmationDialog(orderTemplate: OrderTemplate, modal: ModalDialogComponent<string>) {
    modal.options().titleText = this.translate.instant('account.order_templates.delete_dialog.header', {
      0: orderTemplate.title,
    });
    modal.show(orderTemplate.id);
  }

  getParts(template: OrderTemplate): SkuQuantityType[] {
    return template?.items.map(item => ({ sku: item.sku, quantity: item.desiredQuantity.value }));
  }
}
